<template>
  <section class="app-main">
    <div :class="['app-main-container', mode && 'null', pageRoleMode && 'role-type']">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',
  data() {
    return {
      mode: false,
      pageRoleMode: false
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
    this.mode = (this.$route.name === 'initialPage' || this.$route.name === 'initialPageGrade' || this.$route.name === 'initialPageClass' || this.$route.name === 'studentInfo')
    this.pageRoleMode = (this.userInfo.userType === 1 || this.userInfo.userType === 2) && this.$route.name === 'initialPage'
  },
  watch: {
    '$route'(val) {
      this.mode = (this.$route.name === 'initialPage' || this.$route.name === 'initialPageGrade' || this.$route.name === 'initialPageClass' || this.$route.name === 'studentInfo')
      this.pageRoleMode = (this.userInfo.userType === 1 || this.userInfo.userType === 2) && this.$route.name === 'initialPage'
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 110px);
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: 15px 20px 20px;
  .app-main-container{
    padding: 24px 40px;
    background: #fff;
    min-height: calc(100vh - 190px);
    &.null{
      padding: 0;
      background: inherit;
    }
    &.role-type{
      height: calc(100vh - 190px);
    }
  }
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 160px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
